module.exports = __webpack_public_path__ + "img/titan_sliver.912d052b.png";